<app-dialog
  [title]="'Edit Dimensions'"
  [actions]="[
    { text: 'Cancel', buttonStyle: 'underline' },
    { text: 'Save', isDisabled: form.invalid, spin: spin }
  ]"
  (action)="action($event)"
  (close)="close()"
>
  <div [formGroup]="form">
    <div>
      <div class="dimension">
        <div class="input-container">
          <label class="input-container_label">Length</label>
          <input
            type="number"
            class="input-container_input"
            placeholder="Optional"
            formControlName="regLength"
            min="0"
            (change)="onChange($event, 'RegLength')"
          />
        </div>
        <div class="input-container">
          <label class="input-container_label">Width</label>
          <input
            type="number"
            class="input-container_input"
            placeholder="Optional"
            formControlName="regWidth"
            min="0"
            (change)="onChange($event, 'RegWidth')"
          />
        </div>
        <div class="input-container">
          <label class="input-container_label">Height</label>
          <input
            type="number"
            class="input-container_input"
            placeholder="Optional"
            formControlName="regHeight"
            min="0"
            (change)="onChange($event, 'RegHeight')"
          />
        </div>
        <div class="input-container">
          <label class="input-container_label">Weight</label>
          <input
            type="number"
            class="input-container_input"
            placeholder="Optional"
            formControlName="regWeight"
            min="0"
            (change)="onChange($event, 'RegWeight')"
          />
        </div>
      </div>
    </div>
  </div>
</app-dialog>
